// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface VoteFlagIconSignature {
  Element: SVGSVGElement;
}

export const VoteFlagIcon: TOC<VoteFlagIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2H20V14H5V22H3V2ZM5 12H18V4H5V12Z"/>
</svg>
</template>;